<template>
  <element>
    <AppBar title="AssignReviewer" />
    <v-container>
      <h3 class="category-label w-100 text-center">This is just a dummy view for test.</h3>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "AssignReviewer",
  props: {},
  components: {
    AppBar
  },
  data() {
    return {}
  }
}
</script>

<style>

</style>